// eslint-disable-next-line no-restricted-imports -- It is intended to use it here
import {useSearchParams} from 'react-router-dom';

/**
 * @about Hook to manage state via query string in url
 * @param key key for query params
 * @param replace replace the current entry in the history stack
 * @returns [value, setValue, clearValue]
 * @example
 * const [value, setValue, clearValue] = useQueryState("key")
 */
export function useQueryState(key: string, replace?: boolean) {
  const [searchParams, setSearchParams] = useSearchParams();

  const setValue = (updatedValue: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, updatedValue);
    setSearchParams(params, {replace});
  };

  const clearValue = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
    setSearchParams(params, {replace});
  };

  return [searchParams.get(key), setValue, clearValue] as const;
}
